import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class StrikingForceService {
    // Get all striking forces
    static async getStrikingForces(params = {}) {
        const response = await axiosInstance.get(
            API_PATHS.getstrikingforces,
            { params }
        );
        return response.data;
    }

    // Get striking force by ID
    static async getStrikingForceById(id) {
        const url = API_PATHS.getstrikingforce.replace(":id", id);

        const response = await axiosInstance.get(url);
        return response.data;
    }

    // Add striking force
    static async addStrikingForce(payload) {
        const response = await axiosInstance.post(
            API_PATHS.addstrikingforce,
            payload
        );
        return response.data;
    }

    // Update striking force
    static async updateStrikingForce(id, payload) {
        const url = API_PATHS.updatestrikingforce.replace(":id", id);

        const response = await axiosInstance.put(url, payload);
        return response.data;
    }
}

export default StrikingForceService;